import { getReservations, type Reservation } from '@/hooks/useReservations';
import { orderAcceptsOnlinePayment } from './onlinePayment';
import { paymentWindowMinutes } from './siteSettings';

const RESERVATIONS_KEY = 'aquamarina_reservations_v1';
const CART_KEY = 'sirena_cart_v1';
/** Same margin as the server (netlify/lib/capacity.mjs) before an unpaid reservation is removed. */
const GRACE_MS = 5 * 60_000;

const unpaidTooLong = (reservation: Reservation, windowMs: number, now: number) => reservation.status === 'pendiente'
  && reservation.source !== 'admin'
  && !reservation.mercadoPagoPaymentId
  && orderAcceptsOnlinePayment(reservation.items || [])
  && now > (Date.parse(reservation.createdAt) || 0) + windowMs + GRACE_MS;

/**
 * A reservation started on this device and not paid within the payment window (Cupos in the admin)
 * is removed on the server. When the visitor comes back it goes away here too, with the tours it left in the
 * cart, so the booking starts again from the beginning with today's prices and seats.
 * Runs before the page draws, so the cart never shows the old order.
 */
export function forgetExpiredCheckout(now = Date.now()) {
  try {
    const windowMs = paymentWindowMinutes() * 60_000;
    const reservations = getReservations();
    const expired = reservations.filter((reservation) => unpaidTooLong(reservation, windowMs, now));
    if (!expired.length) return;
    localStorage.setItem(RESERVATIONS_KEY, JSON.stringify(reservations.filter((reservation) => !expired.includes(reservation))));
    const stale = new Set(expired.flatMap((reservation) => reservation.items.map((item) => `${item.tourId}|${item.date}`)));
    const cart: unknown = JSON.parse(localStorage.getItem(CART_KEY) || '[]');
    if (Array.isArray(cart)) {
      localStorage.setItem(CART_KEY, JSON.stringify(cart.filter((item: { tourId?: string; date?: string }) => !stale.has(`${item?.tourId}|${item?.date}`))));
    }
  } catch {
    // Storage blocked or unreadable: nothing was kept on this device anyway.
  }
}
